import React, { useEffect, useState } from "react";
import { Box, Paper, Typography } from "@mui/material";
import {
  InputField,
  RadioField,
  SelectField,
  SearchableSelect,
} from "../FormFields";
import SectionHeading from "../common/SectionHeading";
import indiaData from "../../../../../core/data/json/india_states_and_cities.json";
import { useFormikContext } from "formik";
import useMediaQuery from "@mui/material/useMediaQuery";

const ClientInfo = ({ formField, perFilledData }) => {
  const {
    clientFullName,
    registeredMobileNo,
    registeredEmailAddress,
    clientGender,
    clientAge,
    clientCode,
    city,
    nomineeFullName,
    state,
    stockMarketExperience,
  } = formField;
  const [cities, setCities] = useState([]);
  const { values, setFieldValue } = useFormikContext(); // from Formik
  // console.log("form field values client infor", values);
  const isSmallDevice = useMediaQuery("(max-width:600px)");

  useEffect(() => {
    const selectedState = values.clientDetails?.state;
    if (selectedState) {
      const matchedCities = indiaData[selectedState] || [];
      const cityOptions = matchedCities.map((c) => ({ label: c, value: c }));
      setCities(cityOptions);

      // ❗ Only reset city if it's not part of the new list
      const currentCity = values.clientDetails?.city;
      const isValidCity = matchedCities.includes(currentCity);
      if (!isValidCity) {
        setFieldValue(city.name, "");
      }
    }
  }, [values.clientDetails?.state]);

  return (
    <Box
      sx={{
        p: isSmallDevice ? 0.5 : 1,
        maxWidth: 1000,
        mx: "auto",
        fontSize: { xs: "0.875rem", sm: "1rem" },
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: isSmallDevice ? 2 : 3,
          position: "relative",
          border: "1px solid #e0e0e0",
          borderRadius: 3,
        }}
      >
        <div className="row">
          {/* Client Full Name */}
          <InputField
            name={clientFullName.name}
            label={`1. ${clientFullName.label}`}
            placeholder="Enter your answer"
            required={clientFullName.requiredErrorMsg}
            style={{ fontSize: "inherit" }}
          />

          {/* Registered Mobile Number */}
          <InputField
            name={registeredMobileNo.name}
            label={`2. ${registeredMobileNo.label}`}
            placeholder="Enter your mobile number"
            required={registeredMobileNo.requiredErrorMsg}
            disabled={!!perFilledData.mobile}
            style={{ fontSize: "inherit" }}
          />

          {/* Registered Email Address */}
          <InputField
            name={registeredEmailAddress.name}
            label={`3. ${registeredEmailAddress.label}`}
            type="email"
            placeholder="Please enter an email"
            required={registeredMobileNo.requiredErrorMsg}
            disabled={!!perFilledData.email}
            style={{ fontSize: "inherit" }}
          />

          {/* Client Gender */}
          <RadioField
            name={clientGender.name}
            label={`4. ${clientGender.label}`}
            options={[
              { label: "Male", value: "Male" },
              { label: "Female", value: "Female" },
            ]}
            required={clientGender.requiredErrorMsg}
          />

          {/* Client Age */}
          <InputField
            name={clientAge.name}
            label={`5. ${clientAge.label}`}
            placeholder="Enter your age"
            type="number"
            required={clientAge.requiredErrorMsg}
            style={{ fontSize: "inherit" }}
          />

          {/* Client Code */}
          <InputField
            name={clientCode.name}
            label={`6. ${clientCode.label}`}
            placeholder="Enter client code"
            // required={clientCode.requiredErrorMsg}
            style={{ fontSize: "inherit" }}
          />

          {/* State Dropdown (searchable) */}
          <SearchableSelect
            name={state.name}
            label={`7. ${state.label}`}
            required={state.requiredErrorMsg}
            data={Object.keys(indiaData).map((stateName) => ({
              label: stateName,
              value: stateName,
            }))}
            placeholder="Type to search states"
          />

          {/* Nominee Full Name */}
          <InputField
            name={nomineeFullName.name}
            label={`8. ${nomineeFullName.label}`}
            placeholder="Enter nominee full name"
            required={nomineeFullName.requiredErrorMsg}
            style={{ fontSize: "inherit" }}
          />

          {/* City Dropdown (dependent on State, searchable) */}
          <SearchableSelect
            name={city.name}
            label={`9. ${city.label}`}
            required={city.requiredErrorMsg}
            data={cities}
            placeholder="Type to search cities"
          />

          {/* Stock Market Experience */}
          <SelectField
            name={stockMarketExperience.name}
            label={`10. ${stockMarketExperience.label}`}
            required={stockMarketExperience.requiredErrorMsg}
            data={Array.from({ length: 21 }, (_, i) => ({
              label: `${i} years`,
              value: i,
            }))}
          />
        </div>
      </Paper>
    </Box>
  );
};

export default ClientInfo;
